import { render } from "./FTSWeeklyResponsibleOkatoField.vue?vue&type=template&id=6a571c9a&ts=true"
import script from "./FTSWeeklyResponsibleOkatoField.vue?vue&type=script&lang=ts"
export * from "./FTSWeeklyResponsibleOkatoField.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__